export default __webpack_public_path__ + "static/media/LANG_EN.a1a9c4d6.png";